/**
 * HelpDialog — keyboard shortcuts cheat sheet + slash commands reference.
 * Opened from the Help & feedback menu in the app bar.
 */
import React, { useEffect } from 'react';
import { SLASH_COMMANDS } from './chat/SlashCommandMenu';

export default function HelpDialog({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        aria-label="Keyboard shortcuts and commands"
        style={{ maxWidth: 560 }}
      >
        <div className="modal-header">
          <h2>Keyboard shortcuts &amp; commands</h2>
        </div>
        <div className="modal-body" style={{ fontSize: 13, lineHeight: 1.6 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 8, color: 'var(--text-primary)' }}>
            Keyboard shortcuts
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: '8px 16px', marginBottom: 20 }}>
            <kbd style={{ fontSize: 12, fontFamily: 'ui-monospace, monospace', color: 'var(--text-tertiary)' }}>⌘K / Ctrl+K</kbd>
            <span style={{ color: 'var(--text-secondary)' }}>Focus project search</span>
            <kbd style={{ fontSize: 12, fontFamily: 'ui-monospace, monospace', color: 'var(--text-tertiary)' }}>↵ / ⌘↵</kbd>
            <span style={{ color: 'var(--text-secondary)' }}>Send message</span>
            <kbd style={{ fontSize: 12, fontFamily: 'ui-monospace, monospace', color: 'var(--text-tertiary)' }}>Esc</kbd>
            <span style={{ color: 'var(--text-secondary)' }}>Close dialogs / cancel slash menu</span>
          </div>

          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 8, color: 'var(--text-primary)' }}>
            Slash commands
          </h3>
          <div style={{ fontSize: 12.5, color: 'var(--text-tertiary)', marginBottom: 10 }}>
            Type <code style={{ fontFamily: 'ui-monospace, monospace', color: 'var(--accent-blue)' }}>/</code> in the
            composer to open the command menu.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {SLASH_COMMANDS.map((cmd) => (
              <div key={cmd.cmd} style={{ display: 'flex', gap: 12 }}>
                <code
                  style={{
                    fontFamily: 'ui-monospace, monospace',
                    fontSize: 12,
                    fontWeight: 600,
                    color: 'var(--accent-blue)',
                    minWidth: 100,
                    flexShrink: 0,
                  }}
                >
                  {cmd.cmd}
                </code>
                <span style={{ color: 'var(--text-secondary)' }}>
                  <strong style={{ color: 'var(--text-primary)', fontWeight: 500 }}>{cmd.label}</strong> — {cmd.desc}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="modal-btn modal-btn-primary" onClick={() => onClose?.()}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
